function useTime() {
  let beforeDay = new Date();
  let presentDay = Math.round(beforeDay.getTime() / 1000);
  beforeDay.setDate(beforeDay.getDate() - 1);
  beforeDay = Math.round(beforeDay.getTime() / 1000);
  return { beforeDay, presentDay };
}

export default useTime;
